"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RegexpUtil = _interopRequireDefault(require("../../../../shared/RegexpUtil"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class SearchItems extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.extractLinks = items => items && items.reduce((result, item) => result.concat([{
      label: item.label,
      href: item.uri
    }, ...this.extractLinks(item.children)]), []) || [];
    this.filterSolutions = (query, solutions) => {
      if (!query.trim().length) {
        return [];
      }
      const links = this.extractLinks(solutions);
      const regexp = new RegExp(_RegexpUtil.default.escape(query), 'ig');
      return links.filter(link => regexp.test(link.label)).filter((link, index) => index < 10).map((link, idx) => {
        const matches = link.label.match(regexp);
        return _react.default.createElement(_styles.SearchItemLink, {
          key: `searchItem-${idx}`,
          href: link.href
        }, _react.default.createElement("span", {
          title: link.label
        }, link.label.split(regexp).reduce((result, part, index) => [...result, _react.default.createElement("i", {
          key: `i-part-${idx}-${index}`
        }, part), matches && index < matches.length && _react.default.createElement("b", {
          key: `b-part-${idx}-${index}`
        }, matches[index])], [])));
      });
    };
    this.renderEmptyDataMessage = () => _react.default.createElement(_styles.SearchItemEmpty, null, _react.default.createElement(_styles.Empty, null, this.props.noSearchResult));
  }
  render() {
    const filteredLabels = this.filterSolutions(this.props.query, this.props.solutions);
    return _react.default.createElement("div", null, filteredLabels.length > 0 ? filteredLabels : this.renderEmptyDataMessage());
  }
}
SearchItems.defaultProps = {
  noSearchResult: 'Nothing to show'
};
var _default = exports.default = SearchItems;